import { useParams } from "react-router";
import axios from "axios";
import { useEffect, useState } from "react";
import Navigation from "../../components/Navigation";
import CaseSlider from "../../components/case/CaseSlider";
import ScrollVideo from "../../components/case/scrollVideo";
import Brands from "../../components/Brands";
import TeamSlider from "../../components/team/TeamSlider";
import Footer from "../../components/Footer";
import useApiUrl from "../../framework/hooks/useApiUrlHook";

export default function CaseDetail() {
    const apiUrl = useApiUrl();
    const { name } = useParams();
    const [detail, setDetail] = useState([]);

    const getDetail = () => {
        axios
            .post(`${apiUrl}/case/detail`, { name })
            .then((response) => {
                // console.log(response.data);
                setDetail(response.data);
            })
            .catch((err) => {
                // window.location.replace('/medemerkers');
            });
    };

    useEffect(() => {
        if (apiUrl != null) getDetail();
    }, [apiUrl]);

    return (
        <>
            <Navigation />
            <div className="pro-info-section pt-130">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-8">
                            <div
                                className="pro-info-left"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                            >
                                <h2>{detail.titel}</h2>
                                <h3>{detail.subtitel}</h3>
                            </div>
                        </div>
                        <div className="col-xl-4">
                            <div
                                className="pro-info-right"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                            >
                                <ul className="list-wrap hover-effect">
                                    <li>
                                        <a>
                                            <img src="/assets/img/icons/arrow-right.svg" alt="arrow" /> Klant:
                                        </a>
                                        <ul>
                                            <li>
                                                <a>{detail.klant}</a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="diensten">
                                        <a>
                                            <img src="/assets/img/icons/arrow-right.svg" alt="arrow" /> Diensten:
                                        </a>
                                        <ul>
                                            {detail?.diensten?.map((dienst) => (
                                                <li key={dienst.id}>
                                                    <a href={`/onze-diensten/${dienst.url}`}>
                                                        {dienst.titel}
                                                        {dienst.seperator}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </li>
                                    {detail.projectlink && (
                                        <li>
                                            <a>
                                                <img src="/assets/img/icons/arrow-right.svg" alt="arrow" /> Website:
                                            </a>
                                            <ul className="pro-website-btn">
                                                <li>
                                                    <a target="_blank" href={"https://" + detail.projectlink}>Bekijk
                                                        website</a>
                                                </li>
                                            </ul>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 d-flex justify-content-center">
                            <a href="#" className="scroll-down  pro-scroll-down">
                                <span>SCROLL</span>
                                <img src="/assets/img/icons/arrow-down.svg" alt="icon" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pro-bg-area logo-light">
                <img
                    src={`${apiUrl}/img/extern/ratio/www.bandwerk.nl/klanten_sfeer/orig/2425/1805/100/${detail.image}`}
                    alt="thumb"
                />
            </div>
            <div className="query-area pt-100 pb-50 pt-lg-40 pb-lg-20 pt-md-40 pt-xs-40">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-5">
                            <div
                                className="query-title"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                            >
                                <h1>Vraagstuk</h1>
                            </div>
                        </div>
                        <div className="col-xl-7">
                            <div
                                className="query-question"
                                data-aos="fade-up"
                                data-aos-duration={1000}
                            >
                                <p>{detail.klantvraag}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pro-thumb-area">
                <div className="container">
                    <div
                        className="row align-items-center text-xl-start text-center"
                        data-aos="fade-up"
                        data-aos-duration={1000}
                    >
                        <div className="col-xl-8">
                            <div className="pro-thumb-1">
                                <img
                                    src={`${apiUrl}/img/extern/ratio/www.bandwerk.nl/klanten_bericht/orig/960/1500/100/${detail?.images?.[0]}`}
                                    alt="thumb"
                                />
                            </div>
                        </div>
                        <div className="col-xl-4">
                            <div className="pro-thumb-2">
                                <img
                                    src={`${apiUrl}/img/extern/ratio/www.bandwerk.nl/klanten_bericht/orig/960/1500/100/${detail?.images?.[1]}`}
                                    alt="thumb"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="query-area pt-140 pb-120 pt-lg-40 pb-lg-60  pt-md-40 pt-xs-40">
                <div className="container">
                    <div
                        className="row align-items-center"
                        data-aos="fade-up"
                        data-aos-duration={1000}
                    >
                        <div className="col-xl-5">
                            <div className="query-title">
                                <h1>Oplossing</h1>
                            </div>
                        </div>
                        <div className="col-xl-7">
                            <div className="query-description" dangerouslySetInnerHTML={{ __html: detail.inhoud }} />
                        </div>
                    </div>
                </div>
            </div>
            {detail.quote && (
                <div className="quote-area pt-155 pb-140 pt-lg-130 pb-lg-90 pt-xs-80 pb-xs-80 logo-light">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div
                                    className="quote-content"
                                    data-aos="fade-up"
                                    data-aos-duration={1000}
                                >
                                    <h2>{detail.quote}</h2>
                                    <p>
                                        {detail.contactpersoon} - {detail.klant}
                                    </p>
                                    <div className="icon">
                                        <img src="/assets/img/icons/icon-4.png" alt="icons" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {detail.video && (
                <ScrollVideo detail={detail} />
            )}
            {detail.youtube_video && (
                <div className="pro-video-area pt-150 pb-150 pt-xs-50 pb-xs-50">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12" data-aos="fade-up" data-aos-duration={1000}>
                                <div className="pro-video-thumb w-100 d-flex justify-content-center">
                                    <iframe
                                        className="mw-100 hwaspect-youtube"
                                        width="1161"
                                        height="653"
                                        src={detail.youtube_video}
                                        title="De Jong Beton Rijssen -  Bedrijfsfilm 2023"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <Footer />
        </>
    );
}
